export default __webpack_public_path__ + "static/media/view-dark-accent.7cb169aa.svg";